"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { Col, Row, Skeleton } from "antd"
import { useTranslation } from "react-i18next"
import FlightDealsDesktopSkeleton from "./FlightDealsDesktop.skeleton"


const FlightDealsSkeleton = ({ ...props }: any) => {
  const { t } = useTranslation()

  return (
    <Row {...props} style={{ marginBottom: '3rem', ...props.style }}>
      <Col span={24} style={{ marginBottom: '1rem' }}>
        {props.type === 'DOMESTIC' ? (
          <>
            <Title level={3} style={{ margin: 0 }}>
              {t("home.section_best_price_flights_title")}
            </Title>
            <div className="home__deals-flights--filter-row">
              <Text className="home__deals-flights--filter-label">
                {t("home.section_best_price_flights_from")}
              </Text>
              <div className="home__deals-flights--origin-tabs">
                {[1, 2, 3].map((i) => (
                  <Skeleton.Button
                    key={i}
                    active
                    size="small"
                    shape="round"
                    style={{ width: "10rem", minWidth: "10rem" }}
                  />
                ))}
              </div>
            </div>
          </>
        ) : (
          <Row>
            <Col span={24}>
              <Title
                level={3}
                style={{
                  margin: 0,
                  marginBottom: '0.5rem'
                }}
              >
                {t("home.section_best_price_flights_title_international")}
              </Title>
            </Col>
            {/* {!!destinationOptions.length && (
              <Col span={24}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                  <Button
                    size="small"
                    className="te-btn-round"
                    type={selectedDestinationKey === "__all__" ? "primary" : "default"}
                    onClick={() => setSelectedDestinationKey("__all__")}
                  >
                    Tất cả
                  </Button>
                  {destinationOptions.map((opt) => (
                    <Button
                      key={opt.key}
                      size="small"
                      className="te-btn-round"
                      type={selectedDestinationKey === opt.key ? "primary" : "default"}
                      onClick={() => setSelectedDestinationKey(opt.key)}
                    >
                      {opt.label}
                    </Button>
                  ))}
                </div>
              </Col>
            )} */}
          </Row>
        )}

      </Col>
      <Col span={24}>
        <FlightDealsDesktopSkeleton
          type={props.type}
        />
      </Col>
    </Row>
  )
}

export default FlightDealsSkeleton